import { Field, Label, Textarea, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useTiltakFormContext } from '../utils';

export const BeskrivelseInput = () => {
  const { register, formState } = useTiltakFormContext();
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.tiltakForm' });
  const error = formState.errors.beskrivelse?.message;

  return (
    <Field>
      <Label htmlFor="beskrivelse">{t('beskrivelseInput.label')}</Label>
      <Textarea
        rows={4}
        aria-invalid={!!error}
        {...register('beskrivelse', { required: t('beskrivelseInput.required') })}
      />
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Field>
  );
};
